import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/ui/Layout";
import { LoginPage } from "./pages/LoginPage";
import { ReceiptsPage } from "./pages/ReceiptsPage";
import { ReceiptDetailPage } from "./pages/ReceiptDetailPage";
import { PacksPage } from "./pages/PacksPage";
import { FleetPage } from "./pages/FleetPage";
import { FleetDetailPage } from "./pages/FleetDetailPage";
import { FleetSafetyPage } from "./pages/FleetSafetyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SystemPage } from "./pages/SystemPage";
import { IndexRedirect } from "./pages/IndexRedirect";

// Top-level router. Anything mounted at /panel/* is the SPA; the Go
// side serves index.html as a fallback so deep links work after a
// refresh.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AppShell />}>
        <Route index element={<IndexRedirect />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="receipts" element={<ReceiptsPage />} />
        <Route path="receipts/:id" element={<ReceiptDetailPage />} />
        <Route path="receipts/:id/verify" element={<ReceiptDetailPage />} />
        <Route path="packs" element={<PacksPage />} />
        <Route path="fleet" element={<FleetPage />} />
        <Route path="fleet/:deviceId" element={<FleetDetailPage />} />
        <Route path="safety" element={<FleetSafetyPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="system" element={<SystemPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function NotFound() {
  return (
    <div className="text-center py-12 text-slate-600">
      <p className="text-lg font-medium">404</p>
      <p className="mt-2 text-sm">That page doesn't exist.</p>
    </div>
  );
}
